import { execQuery, extractUserSet } from "../api";
import { SqlDataTable } from "../components/SqlDataTable";
import { SqlPieChart } from "../components/SqlPieChart";
import { openExportUsersModal } from "@/components/elements/ExportUsersModal";

interface Data { name: string, value: number, article_id: string };

const dataQuery = `
select
  (select title from articles where id = article_id) as name,
  count(distinct session_id) as value,
  article_id,
from events where type = 'span' and label = 'article'
and epoch_ms(ts) > (now() - INTERVAL 7 DAY)
group by article_id
having value > 10
order by value desc
`;

const extractUsersQuery = `
select
  user_id
from events where type = 'span' and label = 'article'
and epoch_ms(ts) > (now() - INTERVAL 7 DAY)
and article_id = ?
and user_id is not null
`

export function ArticleViewsChart() {
  return <SqlDataTable
    label="Article Views"
    subtext="Unique views by session. (Last 7 days)"
    width={1200}
    onClick={(data: Data) => {
      let users: Set<string>;
      openExportUsersModal({
        headerContent: <>
          Include only users that have viewed <b>{data.name}</b>.
        </>,
        onDownload: async () => {
          users = await extractUserSet(extractUsersQuery, [data.article_id])
        },
        beforeCsv: async (exportUsers) => {
          return exportUsers.filter(u => users.has(u.id));
        }
      })
    }}
  >{dataQuery}</SqlDataTable>
}